// Thời điểm được phát hành HĐĐT = lúc khách đã nhận hàng (NĐ 123/2020 Đ9).
// Mirror của `handedOver` phía server (usecase/einvoice/einvoice_handover.go):
// đơn giao hàng phải giao xong; đơn "Bán ngay" khách cầm hàng tại quầy nên chốt
// đơn (confirmed) là đủ, không chờ thủ kho xuất kho (M-132).
export function orderHandedOver(
    orderStatus: string | undefined,
    isQuickSale = false,
): boolean {
    if (orderStatus === 'delivered') return true
    return isQuickSale && orderStatus === 'confirmed'
}

/**
 * Mốc khách nhận hàng của đơn: ngày giao, hoặc với đơn "Bán ngay" chưa xuất
 * kho thì lúc tạo đơn (khách cầm hàng tại quầy, M-132). Cùng mốc mà danh sách
 * "Chờ xuất hóa đơn" dùng để xếp đơn chờ lâu nhất lên đầu (M-166).
 * `undefined` = đơn chưa giao.
 */
export function orderHandoverAt(order: {
    delivered_at?: string | null
    is_quick_sale?: boolean
    created_at: string
}): string | undefined {
    return (
        order.delivered_at ??
        (order.is_quick_sale ? order.created_at : undefined)
    )
}
